import { addHours, isSameDay, endOfDay, set, format } from 'date-fns'
import { ja } from 'date-fns/locale'

/**
 * @typedef {Object} GetRoundedAnHourResult
 * @property {Date} startAt
 * @property {Date} endAt
 * 引数の日時を丸め込んだ1時間を取得する
 * 例えば 2022/08/25 12:30:00 の場合
 * startAtが 2022/08/25 12:00:00
 * endAtが 2022/08/25 13:00:00
 * を返す
 * @param {Date} date 
 * @returns {GetRoundedAnHourResult}
 */

export const getRoundedAnHour = (date) => {
  const startDate = set(date, {
    minutes: 0,
    seconds: 0,
    milliseconds: 0
  })
  const endDate = addHours(startDate, 1)
  const startAt = startDate
  const endAt = isSameDay(startDate, endDate) ? endDate : endOfDay(startDate)
  return { startAt, endAt }
}

/**
 * 日付はそのままで時間のみ現在時刻にしたDateを返す
 * @param {Date} date 
 * @returns {Date}
 */
export const getNowTimeDate = (date) => {
  const now = new Date()
  return set(date, {
    hours: now.getHours(),
    minutes: now.getMinutes(),
    seconds: now.getSeconds(),
    milliseconds: now.getMilliseconds()
  })
}

/**
 * InvalidDateかどうかを返す
 * @param {Date} date 
 * @returns {Boolean}
 */
export const isInvalidDate = (date) => {
  return isNaN(date)
}

/**
 * 7/1(月) のようなフォーマットにする
 * @param {Date | String} date
 */
export const formatMdWithJpWeekday = (date) => {
  const d = new Date(date)
  return format(d, 'M/d(E)', { locale: ja })
}

/**
 * 15:00 のようなフォーマットにする
 */
export const formatHHmm = (date) => {
  const d = new Date(date)
  return format(d, 'HH:mm')
}

